import { Age } from "../constants";
import { CognitionPair, IActivityContent } from "./lesson.model";


export const STAR_VALUES = [1, 2, 3, 4] as const;
export type AdventureStars = typeof STAR_VALUES[number];

export const ALG_TYPES = ["Classic", "Custom"];
export type RecommendationType = typeof ALG_TYPES[number];

export const CHEST_RARITY = ["common", "rare", "epic"];
export type AdventureChestRarity = typeof CHEST_RARITY[number];

export const ADVENTURE_CONTENT_TYPES = ["Activity"]
export type AdventureContentType = typeof ADVENTURE_CONTENT_TYPES[number];

export interface CreateAdventure {
	uid?: string;
	version?: number;
	imageId: string;
	name: string;
	lessons: AdventureLesson[];
	age: Age;
	owner: string;
	recommendation: RecommendationAlgorithm;
	releasePhase: string;
}

export interface UpdateAdventure {
	uid?: string;
	imageId: string;
	name: string;
	lessons: AdventureLesson[];
	age: Age;
	owner: string;
	recommendation: RecommendationAlgorithm;
	version?: number;
}

export interface Adventure extends AdventureData {
	uid: string;
}

export interface AdventureData {
	imageId: string;
	name: string;
	lessons: AdventureLesson[];
	age: Age;
	owner: string;
	recommendation: RecommendationAlgorithm;
	version: number;
	isContentValid: boolean;
	releasePhase: string;
	invalidContent?: string[];
	isQAValid?: boolean;
	qaValidationDate?: string;
}

export interface AdventureLesson {
	lessonId: string;
	displayName: string;
	age: string;
	version: number;
}

export interface Recommendation {
	type: RecommendationType;
}

export interface ClassicRecommendation extends Recommendation {
	type: "Classic";
}


export interface CustomRecommendation extends Recommendation {
	type: "Custom";
	stars: AdventureStars;
	starConfig: AdventureStar[];
}

export interface AdventureStar {
	life: number;
	rewards: AdventureReward[];
	content: AdventureContent[];
}

export interface AdventureReward {
	index: number;
	type: AdventureChestRarity;
	amount: number;
}

export interface AdventureContent {
	type: AdventureContentType;
	xp?: number;
	content: AdventureCustomContent;
}

export interface ActivityContent {
	uid: string;
	lessonId: string;
}

export type AdventureCustomContent = ActivityContent;

export type RecommendationAlgorithm = ClassicRecommendation | CustomRecommendation;
